import { graphqlOperation } from 'aws-amplify';

import { InputedWorkflow } from '../../interfaces/graphQL/workflow';
import BaseService, { RequestInterface } from '../Base';
import { AwsConfig } from '../Constants';

export default class WorkflowService extends BaseService {

    constructor(){
      super(AwsConfig.API_CONFIG, 'graphql');
    }


    async getWorkflows(id: string){
      

      const graphQlBody = {
            "query": `{getWorkflow(id: ${id}){ id name nodes{ id process_id notification{ id title message type extractAnswers } name type properties next from assigned{to type} condition run_after}}}`
        }

        const params: RequestInterface = {
            body: graphQlBody
        };

        const res = await super.post('', params)
        return res
    }

    
    async InputWorkflows(workflowData: InputedWorkflow){

      const createItem = `mutation PutWorkflow($data: WorkflowInput!) {
        putWorkflow(data: $data)
      }
      `;
      const variables = {
        name: workflowData.name,
        nodes: workflowData.nodes,
        notifications: workflowData.notifications || []
      }
      const query = graphqlOperation(createItem, {data: variables});
      
      const params: RequestInterface = {
          body: query
      }
      const res = await super.postGraphQl('', params);
      return res
    }

    async deleteWorkflow(id: number){
      const graphQlBody = {
        "query": `mutation{deleteWorkflow(id: ${id})}`
    }
      const params: RequestInterface = {
        body: graphQlBody
      }
      const res = await super.post('', params)
      return res
    }

    async updateWorkflow(id: number, workflowData: InputedWorkflow){

      const intID = parseInt(id)
      const updateItem = `mutation updateWorkflow($id: Int! $data: WorkflowInput!) {
        updateWorkflow(id: $id data: $data)
      }
      `;
      const variables = {
        name: workflowData.name,
        nodes: workflowData.nodes,
        notifications: workflowData.notifications || []
      }
      const query = graphqlOperation(updateItem, {data: variables, id: intID});
      
      const params: RequestInterface = {
          body: query
      }

      const res = await super.postGraphQl('', params);

      return res
    }

    async listWorkflows(){
      const graphQlBody = {
        "query": `{listWorkflows { id name status modified_at created_at}}`
    }

      const params: RequestInterface = {
        body: graphQlBody
      }

      const res = await super.post('', params);
      
      return res
    }

}